var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1368_14527",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1368_14527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3672 45.2708V40.7777C23.4731 40.5342 21.8459 39.8788 20.4855 38.8114C19.1251 37.7441 18.1137 36.2676 17.4512 34.382L19.4981 33.4902C20.1352 35.1436 21.0107 36.4162 22.1248 37.308C23.2388 38.1999 24.75 38.6458 26.6582 38.6458C28.3371 38.6458 29.8709 38.2275 31.2596 37.3909C32.6483 36.5542 33.3427 35.2059 33.3427 33.3458C33.3427 31.7745 32.8316 30.5125 31.8096 29.5598C30.7875 28.6071 28.8751 27.6806 26.0722 26.7803C23.2183 25.8715 21.2096 24.8331 20.046 23.6652C18.8823 22.4974 18.3005 20.9763 18.3005 19.102C18.3005 17.0494 19.0876 15.4102 20.6618 14.1842C22.2359 12.9583 23.8044 12.2958 25.3672 12.1967V7.72913H27.5756V12.1967C29.1044 12.3496 30.4173 12.7736 31.5144 13.4687C32.6115 14.1637 33.5211 15.1525 34.243 16.435L32.281 17.4373C31.7544 16.486 31.0296 15.7159 30.1066 15.127C29.1837 14.5382 28.0087 14.2437 26.5818 14.2437C24.8774 14.2437 23.4392 14.6946 22.2671 15.5963C21.0949 16.4981 20.5089 17.6666 20.5089 19.102C20.5089 20.4582 20.9902 21.5567 21.9528 22.3975C22.9154 23.2384 24.8434 24.1161 27.7369 25.0306C30.4181 25.8799 32.3907 26.9706 33.6548 28.3027C34.9189 29.6348 35.551 31.3073 35.551 33.3203C35.551 35.5371 34.771 37.2981 33.2111 38.6033C31.651 39.9085 29.7725 40.6418 27.5756 40.8032V45.2708H25.3672Z",
    fill: "#00BCD4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachMoney);
export default __webpack_public_path__ + "static/media/attach_money.57198b85267410b1f2e02d6a492328b1.svg";
export { ForwardRef as ReactComponent };